import { first } from 'lodash'
import React from 'react'
import { Form } from 'react-bootstrap'
import useItems from '../../../hooks/use-dimensions'

const DimensionsSelector = ({
    value = [],
    onChange =() => {},
}) => {
    const [ items ] = useItems()
    const dimension = first(value)
    return (
        <Form.Control
            as='select'
            value={dimension}
            onChange={e => onChange([e.target.value])}
            style={{ height: '100%' }}
        >
            <option></option>
            {items.map((item, k) => (<option value={item.id} key={k}>{item.name}</option>))}
        </Form.Control>
    )
}

export default DimensionsSelector